import { render, staticRenderFns } from "./AlcoholAndHealth.vue?vue&type=template&id=22d1d0b1"
import script from "./AlcoholAndHealth.vue?vue&type=script&lang=js"
export * from "./AlcoholAndHealth.vue?vue&type=script&lang=js"
import style0 from "./AlcoholAndHealth.vue?vue&type=style&index=0&id=22d1d0b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports